import { render, staticRenderFns } from "./showOrder.vue?vue&type=template&id=c2457134&scoped=true&"
import script from "./showOrder.vue?vue&type=script&lang=js&"
export * from "./showOrder.vue?vue&type=script&lang=js&"
import style0 from "./showOrder.vue?vue&type=style&index=0&id=c2457134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2457134",
  null
  
)

export default component.exports